import { Call } from '@material-ui/icons';
import moment from 'moment';
import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import { fetchAPIData } from '../../../../service/service';
import PaymentProcess from '../../../modals/PaymentProcess/PaymentProcess';
import PersoanlInfoModel from '../../../modals/PersonInfo modal/PersonInfoModal';
import "./ProfileCard.scss";
import MessageForCustomer from '../../../modals/MessageForCustomer/MessageForCustomer'
import PaymentActionDialog from './PaymentActionDialog';

import {
    redcross as redCross, message as Sms, userdefault as profileImg,
    greentick as greenTick, backArrowWhite as backArrow
} from '../../../../assets/images';
import { getSecureItem, setSecureItem } from '../../../../utilsFunctions';
import axios from 'axios';
import { BaseUrl } from '../../../../Environment';
import ImageZoomModal from '../../../modals/ImageZoomModal';







class ProfileCard extends Component {

    constructor(props) {
        super(props);
        this.state = {
            personalDetails: { name: null, phoneNo: null, loanID: null, otherLoanIDs: [1] },
            nextDue: { dueDate: null, dueAmount: null, installment: null, penalty: null },
            previousDue: { dueDate: null, tobePaid: null, paid: null, paymentMode: null },
            previousDueList: [],
            isPayProcessOpen: false,
            paymentAction: null,
            isPersonalInfoActive: false,
            customerInfo: {},
            openmodal: false,
            row: "",
            receivePaymentType: "",
            showWhatsAppDialog: false,
            whatsAppData: null,
            compData:{},
            collectionAmount:"",
            penalty:"",
            collaterals:{},
            fromOverDue:false,
        };

    }

    componentWillReceiveProps(nextProps) {
        const { personalDetails, nextDue, previousDueList, loanStatus, isLastDue } = nextProps.personalCardDetail
        const { isLoanActive, cancellationReason, customerInfo, fromOverDue, notPaidCollection, updatePreviousCollection } = nextProps
        customerInfo.noOfLoans = personalDetails.otherLoanIDs.length;


        this.setState({
            personalDetails: personalDetails,
            nextDue: nextDue,
            previousDueList: previousDueList,
            customerInfo: customerInfo,
            loanStatus: loanStatus,
            cancellationReason: cancellationReason,
            isLoanActive: isLoanActive,
            isLastDue: isLastDue,
            fromOverDue: fromOverDue,
            notPaidCollection: notPaidCollection,
            updatePreviousCollection: updatePreviousCollection,    
            pendingPaymentAction: nextProps.changePaymentProcessStatus || null,
        });
    }

    componentDidUpdate(prevProps) {
        const { changePaymentProcessStatus } = this.props;
        if (
            changePaymentProcessStatus &&
            changePaymentProcessStatus !== prevProps.changePaymentProcessStatus
        ) {
            this.changePaymentProcessStatus(changePaymentProcessStatus);
        }
    }

    onBackArrowClick = () => {
        this.props.history.goBack()
    }

    onPersonalInfoClick = async () => {
        let customerInfo = []
        let { isPersonalInfoActive } = this.state
        isPersonalInfoActive = !isPersonalInfoActive
        this.setState({ isPersonalInfoActive });
        if (isPersonalInfoActive) {
            customerInfo = await fetchAPIData('customerDetailByID', this.state.personalDetails.customerID)
            this.setState({ customerInfo });
        }

    }

    handleReceivePayment = (type) => {
        if (type) this.setState({ receivePaymentType: type });
        if (this.props.notPaidCollection && this.props.onReceivePaymentClick) {
            this.props.onReceivePaymentClick();
        } else {
            this.changePaymentProcessStatus('pay');
        }
    }

    changePaymentProcessStatus = (value) => {
        if (value === 'pay' || value === 'notpay') {
            this.setState({ isPayProcessOpen: true, paymentAction: value });
        }
        else
            this.setState({ isPayProcessOpen: false, paymentAction: null });
    }

    notDone = () => {
        alert("Oops! sorry, this features is under construction")
    }
    messagecustomer = (details, value) => {
        this.setState({
          openmodal: true,
          row: details
        })
      }
      closemodal=()=> {
        this.setState({
          openmodal: false
        })
      }

    async sendSMS({ mobile, message }) {
        try {
            const res = await axios.post(
                `${BaseUrl}/sms/sendKenyaSMS`,
                {
                    mobile: mobile,
                    message: message,
                },
                {
                    headers: {
                        "Content-Type": "application/json"
                    }
                }
            );

            return res.data;

        } catch (error) {
            console.error("SMS Error:", error.response?.data || error.message);
            throw error;
        }
    }

    onPaymentBtnClk = async (nextDue, loanID) => {
        const { action, method } = this.props;

        const result = await fetchAPIData("paymentAction", {
            nextDue,
            name: this.state.personalDetails.name,
            mobNo: this.state.personalDetails.phoneNo,
            loanID,
            method,
        });
        this.props.onPaymentDone();
        if (result?.showWhatsAppDialog) {
            // const isParadex = getSecureItem("loggedinUserCompany") == "2234";
            // if(isParadex){
            //     try {
            //         const response = await this.sendSMS({ mobile: result.mobNo, message: result.message });
            //         // console.log("Kenya SMS Response:", response);
            //     } catch (error) {
            //         console.error("SMS failed:", error);
            //     }
            // }
            this.setState({
                showWhatsAppDialog: true,
                whatsAppData: { mobNo: result.mobNo, message: result.message },
                compData:result.compData,
                collectionAmount:result.collectionAmount,
                collaterals:result.collaterals,
                penalty:result.penalty
            });
        }

        action(loanID);
    };


    render() {

        const { isPayProcessOpen, customerInfo, isPersonalInfoActive,
            paymentAction, personalDetails, nextDue, previousDueList, isLoanActive,
            isLastDue, cancellationReason, receivePaymentType, collaterals, updatePreviousCollection, notPaidCollection} = this.state

        const userPermissions = getSecureItem("UsersAccess");
        const hideModal = getSecureItem("loggedinUserCompany") != "2573";
        return (
            <div className="ProfileCard Fonts"  >

                <PaymentProcess
                    isFromLink={false}
                    isOpen={isPayProcessOpen}
                    paymentAction={paymentAction}
                    changePaymentProcessStatus={this.changePaymentProcessStatus}
                    onPaymentBtnClk={this.onPaymentBtnClk}
                    loanId={personalDetails.loanID}
                    personalDetails={personalDetails}
                    method={this.props.method}
                    nextDue={nextDue}
                    receivePaymentType={receivePaymentType}
                    updatePreviousCollection={updatePreviousCollection}
                    notPaidCollection={notPaidCollection}
                />

                <PersoanlInfoModel open={isPersonalInfoActive} close={this.onPersonalInfoClick} customerInfo={customerInfo} mainPage={true} />

                <div className="InsideProfileCard">
                    <div className="Header" >
                        <img className="BackArrow" onClick={this.onBackArrowClick} src={backArrow} alt={'backarrow'} />
                        <div className="PersonalInfo Fonts">

                            <div className="InfoLink Fonts" onClick={this.onPersonalInfoClick} >Personal Info</div>
                        </div>
                    </div>
                    <div className="Profile Fonts" >
                        <div className="ProfileCardLayout Fonts">
                            <ImageZoomModal
                                src={personalDetails.profilePhoto}
                                alt="Profile picture"
                                size={72}
                                allowDownload={true}
                                fileName="profile.jpg"
                            />
                            <h2 className="PersonName Fonts">{personalDetails.name}</h2>
                            <LoanItemList action={this.props.action} active={personalDetails.loanID} otherLoanIDs={personalDetails.otherLoanIDs} />
                            <h6 className="LoanNumber Fonts" > Loan Number</h6>
                            <div className="Contact Fonts">
                                <h4 className="phoneNo Fonts" >
                                    <Call className="ContactIcon Fonts" />
                                    {personalDetails.phoneNo}  </h4>
                                <img className="ContactIcon" onClick={this.messagecustomer.bind(this, personalDetails.phoneNo)} src={Sms} alt={'sms'} />
                            </div>
                        </div>
                    </div>

                    {(nextDue.installment && isLoanActive) &&

                        <div className="NextPayment Fonts">
                            <div className="PaymentDetails Fonts" >
                                <h4 className="PaymentHeader Fonts" >NEXT PAYMENT</h4>
                                <span className="PaymentHeader1 Fonts">{nextDue.dueDate ? moment(nextDue.dueDate).format("DD MMM  YYYY") : ""}</span><br />
                                <div className="PaymentHeader2 Fonts"> {nextDue.collectionAmount}</div>
                                <div className="PaymentHeader3 Fonts"><span style={{ color: "white" }}>{nextDue.collectionAmount - nextDue.penalty}</span> Principal &nbsp;&nbsp;&nbsp; | &nbsp;<span style={{ color: "white" }}>{nextDue.penalty}</span> Penalty</div><br /><br />
                            </div>
                            <div style={{visibility: userPermissions?.receivePayment ? "visible" : "hidden", display: "flex", flexDirection: "column", marginLeft: 30}} className="PaymentLayout Fonts">
                                {this.props.method != 'interestOnly' && <button
                                    onClick={() => this.handleReceivePayment()}
                                    className="PaidButton Fonts">
                                    Receive Payment
                                </button>}
                                {this.props.method == 'interestOnly' && <button
                                    onClick={() => this.handleReceivePayment("Interest")}
                                    className="PaidButton Fonts">
                                    Receive Interest
                                </button>}
                                {this.props.method == 'interestOnly' && <button
                                    onClick={() => this.handleReceivePayment("Principal")}
                                    className="PaidButton Fonts">
                                    Receive Principal
                                </button>}

                                {
                                    <button
                                        //  onClick={() => this.onPaymentBtnClk(nextDue, "Not Paid", personalDetails.loanID)}
                                        onClick={() => { this.changePaymentProcessStatus('notpay') }}
                                        className="NotPaidButton Fonts">
                                        Not Paid
                                    </button>
                                }
                            </div>
                        </div>
                    }
                    {!isLoanActive && cancellationReason !== null && <CancelReason reason={cancellationReason} />}




                    <div className="PreviousTransaction">
                        <h4 className="TransactionHisHeader" >TRANSACTION&nbsp; HISTORY</h4>
                        <div className="TransactionHisBody" >
                            {previousDueList.map((previousDue, index) =>
                                <CardHistory key={index} previousDue={previousDue} onResonClick={this.notDone} />
                            )}
                        </div>

                    </div>
                </div>
                <MessageForCustomer open={this.state.openmodal} close={this.closemodal} rowData={this.state.row} />
                {hideModal && this.state.showWhatsAppDialog && (
                    <PaymentActionDialog
                        mobNo={this.state.whatsAppData.mobNo}
                        message={this.state.whatsAppData.message}
                        onClose={() => this.setState({ showWhatsAppDialog: false, whatsAppData: null })}
                        personalDetails={personalDetails}
                        compData={this.state.compData}
                        collectionAmount={this.state.collectionAmount}
                        penalty={this.state.penalty}
                        dueCount={previousDueList.length}
                        collaterals={collaterals}
                    />
                )}
            </div>
        );
    }
}

export default withRouter(ProfileCard);

let CardHistory = (props) => {
    const { previousDue } = props
    const isPaid = previousDue.collectionStatus === 'Paid';
    return (
        <div className="historyCard" >
            <div className="calenderLayout">
                {moment(previousDue.collectedDate ?? previousDue?.updatedAt).format("MMM")}
                <br />
                {moment(previousDue.collectedDate ?? previousDue?.updatedAt).format("DD")}

            </div>
            <div className="InstallmentLayout">
                <div className="InstallmentHeader">
                    <h4 className="Installment" >{previousDue.collectionAmount}</h4>
                </div>
                <div className="Payment">{previousDue.Installment}<span className="PaymentText">&nbsp; Installment</span></div>
            </div>
            <div className="paymentStatus" >
                {isPaid && <span>&bull; {previousDue.paymentType}</span>}

                {/* <div style={{ marginLeft: 'auto' }}> */}

                <div className={isPaid ? "green" : "red"} >
                    {isPaid ? `${previousDue.paymentMode?.toLowerCase()} ` : `Not Paid `}
                    <img src={isPaid ? greenTick : redCross} alt={'paidIcon'} />
                </div>

                {/* Since Not Paid is not shown in Transaction history, below 4 lines are commented */}
                {/* {!isPaid &&
                        <Tooltip title="Reason for not paid" placement="right">
                            <div className="reasonLayout" onClick={onResonClick} >Reason</div>
                        </Tooltip>
                    } 
                </div> */}
            </div>
        </div>
    )
}


let LoanItemList = (props) => {

    const { otherLoanIDs, active } = props

    let handleSelectChange = (event) => {
        const { action } = props
        let loanID = event.target.value
        setSecureItem('loanId', loanID)
        action(loanID)

    }

    return (
        <div>
            <select className="dropDown" value={active || ""} onChange={(e) => { handleSelectChange(e) }}>
                {otherLoanIDs
                    .map((obj, index) => (
                        <option className="dropDownOption" key={index} value={obj.loanId}  >{obj.loanId}</option>
                    ))}
            </select>
        </div>
    )
}



const CancelReason = props => {
    const { reason } = props

    return (
        <div className='cancelReasonLayout' >
            <div className='innerLayout' >
                <h3> REASON FOR CANCELLATION</h3>
                <p>{reason}</p>
            </div>
        </div>
    )

}